import {RequestAxios} from "../../index";
import {PersonnelList} from "./interfaces";
import {API_START} from "../../constants";

export const getPersonnelList = async (id: number) => {
    const personnelUrl = `${API_START}/stores/${id}/personnel`;
    return await RequestAxios.get<PersonnelList[]>(personnelUrl)
}